import {call, put, select} from "redux-saga/effects";
import {
  addSectionsToPage,
  deleteDynamicItems,
  deleteSectionsFromPage,
  getDynamicItemsPaginated,
  getPageSelectedItems,
  getSectionById,
  patchBulkUpdateItemsInPage,
  patchPriorityOfPageSections,
  postDynamicItem,
  putDynamicItem,
} from "../requests/dynamicUiService";
import {
  setItemsLoading as setLoading,
  setGetItemsResult,
  setTransferLoading,
  setAddItemsLoading,
  setAddItemsResult,
  setItemsDeleting,
  setDeleteItemsResult,
  setTransferItemsResult,
  setBulkUpdateLoading,
  setBulkUpdateResult,
  setUpdateItemsResult,
  setDynamicPages,
  setPagesAddingOrEditing,
  setSelectedData,
  resetAddItemsData,
  setSearchResultLoading,
  setSearchResult
} from "../../slices/dynamicUiSlice";
import {toast} from "react-toastify";
import {
  TAB_DEFAULT,
  TAB_PRODUCTS,
  UI_TYPE_FOCUSED,
  UI_TYPE_NORMAL
} from "pages/dynamicUi/constants";
import {setLoading as setDynamicLoading} from "../../slices/dynamicElementsSlice";
import { deleteDynamicUiPage, getAllDynamicUiPages, postDynamicUiPage, putDynamicUiPage } from '../requests/pageService'

export function* handleGetAllItems(action) {
  const tab = yield select((state) => state.dynamicUi.items.activeTab);
  const type = yield select((state) => state.dynamicUi.items[tab].selected);
  const currentPage = yield select((state) => state.dynamicUi.items[tab][type].meta.page);
  try {

    yield put(setLoading(true));
    const {data} = yield call(() => getDynamicItemsPaginated(type, currentPage, tab));
    yield put(setGetItemsResult(data));
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(`Error: ${errMsg}`);
    yield put(setGetItemsResult({error: errMsg, page: currentPage}));
  }
}

export function* handleGetSelectedItems() {
  const selectedPage = yield select((state) => state.dynamicUi.pages.selectedPage);
  try {
    yield put(setSelectedData({id: selectedPage, loading: true}));
    const {data} = yield call(() => getPageSelectedItems(selectedPage));
    yield put(setSelectedData({id: selectedPage, data}));
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    // toast.error(`Error: ${errMsg}`);
    yield put(setSelectedData({id: selectedPage, error: errMsg}));
  }
}

export function* handleGetDynamicUiPages(action) {
  const {all = false} = action.payload ?? {};
  try {
    yield put(setDynamicPages({loading: true, all}));
    const selectedGroup = yield select((state) => state.dynamicUi.pages.selectedGroup);
    const {data} = yield call(() => getAllDynamicUiPages(selectedGroup,all));
    yield put(setDynamicPages({data: data.data, all}));


    // if(!data?.data.length){
    //   toast.error(`Error: No pages in this group`);
    //   yield put(setSelectedPageGroup({group: DYNAMIC_PAGE_GROUP_MONTH}));
    // }
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    // toast.error(`Error: ${errMsg}`);
    yield put(setDynamicPages({error: errMsg, all}));
  }
}

export function* handleAddOrUpdateDynamicUiPage(action) {
  const element = "editing";
  const {pageData, editing} = action.payload;
  try {
    yield put(setDynamicLoading({loading: true, element}));
    const {data} = yield call(() => editing ? putDynamicUiPage(editing.id.substring(1), pageData) : postDynamicUiPage(pageData));

    yield put(setDynamicPages({'add': data, editing}));
    yield put(setPagesAddingOrEditing({clear: true}));
    yield put(setDynamicLoading({loading: false, element}));
    toast.success(`${editing ? 'Edited' : 'Added'} Page Successfully`);
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(`Error: ${errMsg}`);
    yield put(setDynamicLoading({loading: false, element}));
  }
}

export function* handleDeleteDynamicUiPage(action) {
  const element = "editing";
  const {deleting} = action.payload;
  try {
    yield put(setDynamicLoading({loading: true, element}));
    yield call(() => deleteDynamicUiPage(deleting.id.substring(1)));

    yield put(setDynamicPages({remove: deleting.id}));
    yield put(setPagesAddingOrEditing({clear: true}));
    yield put(setDynamicLoading({loading: false, element}));
    toast.success(`Deleted Page Successfully`);
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(`Error: ${errMsg}`);
    yield put(setDynamicLoading({loading: false, element}));
  }
}

export function* handleAddItems({payload}) {
  try {
    yield put(setAddItemsLoading(true));
    const isEdit = payload.formData?.edit;
    const displayType = payload.uiType.value === UI_TYPE_FOCUSED ? payload.data.display_type : '';
    const extras = (payload.uiType.value === UI_TYPE_FOCUSED || payload.uiType.value === UI_TYPE_NORMAL) && payload.data.extras ? payload.data.extras : {};
    const tab = yield select((state) => state.dynamicUi.items.activeTab);

    const selectedTab = yield select((state) => state.dynamicUi.items[tab].selected);
    if (isEdit) {
      const {data} = yield call(() => putDynamicItem(payload.formData['id'], {...payload, displayType, extras}));
      yield put(setUpdateItemsResult(data));
      yield put(resetAddItemsData({except: selectedTab}));
      toast.success("Successfully updated the entries.");
    } else {

      const {data} = yield call(() => postDynamicItem({...payload, displayType, extras}));

      const except = selectedTab === TAB_DEFAULT || selectedTab === TAB_PRODUCTS ? selectedTab : "";

      yield put(resetAddItemsData({except}));
      yield put(setAddItemsResult(data));


      toast.success("Successfully added a new entry.");
    }


  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(`Error: ${errMsg}`);
    yield put(setAddItemsResult({error: errMsg}));
  }
}

export function* handleBulkUpdateItems({payload}) {

  const selectedPage = yield select((state) => state.dynamicUi.pages.selectedPage);

  try {


    yield put(setBulkUpdateLoading(true));
    const itemList = payload.map((item) => ({section_id: item.section.id}));
    const {data} = yield call(() => patchBulkUpdateItemsInPage(selectedPage, itemList));
    yield put(setBulkUpdateResult({...data, id: selectedPage}));
    toast.success("Successfully updated the app UI.");
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(`Error: ${errMsg}`);
    yield put(setBulkUpdateResult({error: errMsg}));
  }
}

export function* handleDeleteItems({payload}) {
  try {
    yield put(setItemsDeleting(true));
    yield call(() => deleteDynamicItems(payload));
    yield put(resetAddItemsData({}));
    yield put(setDeleteItemsResult(payload));

    toast.success('Delete success');
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(`Error: ${errMsg}`);
    yield put(setItemsDeleting(false));
  }
}

export function* handleTransferItems({payload: {id, remove, sectionId: selectedId, priority, section, is_quickee}}) {
  const selectedPage = yield select((state) => state.dynamicUi.pages.selectedPage);

  try {
    yield put(setTransferLoading(true));
    if (remove) {
      // yield call(() => removeFromSelectedItems(sectionId));
      yield call(() => deleteSectionsFromPage(selectedPage, selectedId));
      toast.success('Removed item from the UI');
      yield put(setTransferItemsResult({id: selectedPage, remove, sectionId: id}));
    } else if (section) {

      const {data} = yield call(() => patchPriorityOfPageSections(selectedPage, id, priority, is_quickee));
      yield put(setTransferItemsResult({data, update: true, id: selectedPage}));
      toast.success('Updated the position');
    } else {
      //add logic
      const {data} = yield call(() => addSectionsToPage(selectedPage, id, priority, is_quickee));
      // yield call(() => getDynamicItemsTest());
      yield put(setTransferItemsResult({data, id: selectedPage}));
      // yield put(setTransferItemsResult({
      //   "section": {
      //     "sections": [],
      //     "type": "FOCUSED>>",
      //     "display_type": "",
      //     "sub_type": "BRAND>>",
      //     "value": "2",
      //     "id": "1080e78e-ffae-4ecb-8528-88aad6780c8e",
      //     "is_default": false
      //   },
      //   "priority": 1,
      //   "id": "bla bla bla",
      //   "section_id": "1080e78e-ffae-4ecb-8528-88aad6780c8e"
      // }));
      toast.success('Added successfully to the UI');
      // yield put(setDeleteItemsResult(payload));
    }

  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(`Error: ${errMsg}`);
    yield put(setTransferLoading(false));
  }
}

export function* handleGetSection(action) {
  try {
    yield put(setSearchResultLoading());
    const {data} = yield call(() => getSectionById(action.payload));
    yield put(setSearchResult({data}));
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(`Error: ${errMsg}`);
    yield put(setSearchResult({error: errMsg }));
  }
}
